// @flow
import * as React from "react";
import { withTranslation } from "react-i18next";
import { Button, Message, Form } from "semantic-ui-react";

import "./SaveButton.scss";
type Props = {|
  t: typeof TFunction,
  submitting: boolean,
  invalid: boolean,
  error: boolean,
  onClick: Function,
  submitSucceeded: boolean,
|};

const SaveButton = (props: Props) => {
  const { t, submitting, invalid, error, submitSucceeded, onClick } = props;

  return (
    <div className="SaveButton">
      <Form.Group>
        <Form.Field width={6} />
        <Form.Field width={5}>
          <Button
            secondary
            fluid
            loading={submitting}
            negative={!!error}
            disabled={invalid || submitting || !!error}
            icon={error ? "warning circle" : "check"}
            labelPosition="right"
            content={error ? t("failed") : t("save")}
            onClick={onClick}
          />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={6} />
        <Form.Field width={10}>
          {submitSucceeded && <Message positive content={t("changeService:wizard.savingWasSuccessful")} />}
          {error && <Message negative content={t("changeService:wizard.savingFailed")} />}
        </Form.Field>
      </Form.Group>
    </div>
  );
};

export default withTranslation("common")(SaveButton);
